import { useEffect } from "react";
import { Container } from "react-bootstrap";
import styled from "styled-components";
import Button from "../../components/Button";
import Header from "../../components/Header";
import { Heading3 } from "../../components/Typography";
import { COLOR_WHITE, COLOR_YELLOW } from "../../constants/colors";
import { useAppContext } from "../../contexts/App";
import bgGray from "../../images/bg-gray.png";

const Background = styled.div`
  min-height: 100vh;
  background-image: url(${bgGray});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  display: flex;
  flex-direction: column;
`;

const StyledContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  margin-bottom: 100px;
`;

const Title = styled.h1`
  ${Heading3}
  color: ${COLOR_WHITE};
  text-align: center;
`;

function TransactionSuccess() {
  const appContext = useAppContext();

  useEffect(() => {
    localStorage.removeItem("cart");
    if (appContext) {
      appContext.setCartItemCount(0);
    }
  }, [appContext]);

  return (
    <Background>
      <Header />
      <StyledContainer>
        <Title className="mb-4">
          Thank you for your order.
          <br />
          <span style={{ color: COLOR_YELLOW }}>We’re going to process it as fast as we can</span>
        </Title>
        <a href="/">
          <Button variant="primary" size="lg">
            Back to Home
          </Button>
        </a>
      </StyledContainer>
    </Background>
  );
}

export default TransactionSuccess;
